/* LoadingSuspenseSpinner.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import Spinner from '@atlaskit/spinner';
import * as React from 'react';
const _3 = "._19pkxy5q{margin-top:var(--ds-space-400,2pc)}";
const _2 = "._1bsb1osq{width:100%}";
const _ = "._y3gn1h6o{text-align:center}";
const SpinnerContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_y3gn1h6o _1bsb1osq _19pkxy5q", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SpinnerContainer.displayName = 'SpinnerContainer';
}
export const LoadingSuspenseSpinner = () => /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(Spinner, {
  size: "large"
}));